(() => {
  const STORAGE_KEY = 'wowthings:recently-viewed';
  const MAX_ENTRIES = 12;

  const read = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const write = (entries) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
    } catch (error) {
      // Storage unavailable (private mode, quota) — fail silently, feature is non-critical.
    }
  };

  const record = ({ url, handle }) => {
    if (!url || !handle) return;

    const withoutDuplicate = read().filter((entry) => entry.handle !== handle);
    withoutDuplicate.unshift({ url, handle, viewedAt: Date.now() });
    write(withoutDuplicate.slice(0, MAX_ENTRIES));
  };

  const clear = () => write([]);

  window.WowRecentlyViewed = { record, list: read, clear };

  const hydrate = async (section) => {
    const track = section.querySelector('[data-recently-viewed-track]');
    if (!track) return;

    const limit = Number.parseInt(section.dataset.productsLimit, 10) || 8;
    const entries = read().slice(0, limit);
    if (!entries.length) return;

    const results = await Promise.allSettled(
      entries.map((entry) => fetch(`${entry.url}?section_id=recently-viewed-card`).then((response) => {
        if (!response.ok) throw new Error('Recently viewed fetch failed');
        return response.text();
      }))
    );

    let renderedAny = false;
    results.forEach((result) => {
      if (result.status !== 'fulfilled' || !result.value.trim()) return;
      track.insertAdjacentHTML('beforeend', result.value);
      renderedAny = true;
    });

    if (!renderedAny) return;

    section.hidden = false;

    const clearButton = section.querySelector('[data-recently-viewed-clear]');
    clearButton?.addEventListener('click', () => {
      clear();
      section.hidden = true;
      track.textContent = '';
    });
  };

  window.addEventListener('load', () => {
    document.querySelectorAll('[data-recently-viewed]').forEach((section) => hydrate(section));
  });
})();
